import { render, staticRenderFns } from "./PreferredTreatment.vue?vue&type=template&id=7abd6e68&scoped=true"
import script from "./PreferredTreatment.vue?vue&type=script&lang=js"
export * from "./PreferredTreatment.vue?vue&type=script&lang=js"
import style0 from "./PreferredTreatment.vue?vue&type=style&index=0&id=7abd6e68&prod&scoped=true&lang=css"
import style1 from "./PreferredTreatment.vue?vue&type=style&index=1&id=7abd6e68&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7abd6e68",
  null
  
)

export default component.exports